// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dkmX","title":"Info_title__E0ttx","links":"Info_links__jDUq4","link":"Info_link__brxS4","logo":"Info_logo___gNvU"};